<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const formulaImageSrc = cfgToThemeCdnPath("/about-vip/modern/rakeback-formula.png");
const splitFormula = (formula) => {
	const parts = formula.split(" x ");
	if (parts.length < 2) return {
		left: formula,
		right: ""
	};
	const right = parts.pop();
	return {
		left: parts.join(" x "),
		right: `x ${right}`
	};
};
const formula = $derived(splitFormula($t(Verbiage.vip_modern_total_wagered_x_house_edge_x_rakeback)));
</script>

<InfoCard
	modernStyle
	modernBordered={false}
	modernGlowPosition="left"
	width="100%"
	noPadding
	borderRadius="20px"
	customClass="vip-rakeback-card"
>
	<div class="vip-rakeback">
		<div class="vip-rakeback-content">
			<VipModernEyebrow text={$t(Verbiage.vip_modern_the_formula)} />
			<Text
				type="title"
				titleSize="h4"
				titleWeight="bold"
				textColor="white"
				className="vip-rakeback-title"
			>
				{$t(Verbiage.rakeback)}
			</Text>
			<Text type="body" bodySize="large" textColor="white">
				{$t(Verbiage.vip_modern_rakeback_body)}
			</Text>
		</div>

		<InfoCard
			modernStyle
			modernGlowPosition="right"
			modernGlowSize="90%"
			noPadding
			borderRadius="16px"
			customClass="vip-rakeback-formula-card"
		>
			<div class="vip-rakeback-formula">
				<Text type="title" titleSize="h6" titleWeight="bold" textColor="white">
					{$t(Verbiage.vip_modern_formula)}
				</Text>

				<img
					class="vip-rakeback-formula-img"
					src={formulaImageSrc}
					alt={$t(Verbiage.illustration_alt, 'alts')}
				/>

				<Text type="body" bodySize="medium" className="vip-rakeback-formula-text">
					<span class="vip-rakeback-formula-blue">({formula.left})</span>
					<span class="vip-rakeback-formula-green">{formula.right}</span>
				</Text>
			</div>
		</InfoCard>

		<div class="vip-rakeback-bullets">
			<InfoCard
				modernStyle
				modernGlowPosition="left"
				noPadding
				borderRadius="8px"
				customClass="vip-rakeback-bullet"
			>
				<div class="vip-rakeback-bullet-inner">
					<span class="vip-rakeback-bullet-icon">
						<span class="vip-rakeback-dot"></span>
					</span>
					<Text type="body" bodySize="small" textColor="white">
						{$t(Verbiage.vip_modern_rakeback_gets_better_with_each_tier)}
					</Text>
				</div>
			</InfoCard>
			<InfoCard
				modernStyle
				modernGlowPosition="left"
				noPadding
				borderRadius="8px"
				customClass="vip-rakeback-bullet"
			>
				<div class="vip-rakeback-bullet-inner">
					<span class="vip-rakeback-bullet-icon">
						<span class="vip-rakeback-dot"></span>
					</span>
					<Text type="body" bodySize="small" textColor="white">
						{$t(Verbiage.vip_modern_rakeback_cooldown_body)}
					</Text>
				</div>
			</InfoCard>
		</div>
	</div>
</InfoCard>

<style>
	.vip-rakeback {
		position: relative;
		display: grid;
		width: 100%;
		gap: 1.5rem;
		padding: 1.5rem;
		grid-template-areas: 'content' 'formula' 'bullets'
}

	.vip-rakeback-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 1.5rem;
		grid-area: content
}

	:global(.vip-rakeback-title) {
		font-size: 32px !important
}

	.vip-rakeback-bullets {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.75rem;
		grid-area: bullets
}

	:global(.vip-rakeback-bullet) {
		width: 100%
}

	.vip-rakeback-bullet-inner {
		display: flex;
		width: 100%;
		align-items: flex-start;
		gap: 0.75rem;
		padding: 1rem
}

	.vip-rakeback-bullet-icon {
		margin-top: 0.25rem;
		display: flex;
		flex-shrink: 0;
		flex-direction: column;
		align-items: center;
		gap: 0.25rem
}

	.vip-rakeback-dot {
		display: block;
		height: 0.375rem;
		width: 0.375rem;
		border-radius: 9999px;
		background-color: var(--color-highlight-3);
		--tw-shadow: 0 0 6px 1px var(--color-highlight-3);
		--tw-shadow-colored: 0 0 6px 1px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

	:global(.vip-rakeback-formula-card) {
		width: 100%;
		grid-area: formula
}

	.vip-rakeback-formula {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
		padding: 1.5rem
}

	.vip-rakeback-formula-img {
		height: auto;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain
}

	:global(.vip-rakeback-formula-text) {
		display: flex;
		flex-wrap: wrap;
		-moz-column-gap: 0.5rem;
		     column-gap: 0.5rem
}

	.vip-rakeback-formula-blue {
		color: var(--color-primary-300)
}

	.vip-rakeback-formula-green {
		font-weight: 600;
		color: var(--color-accent-100)
}

	@media (min-width: 1024px) {
		.vip-rakeback {
				grid-template-columns: 55% 45%;
				padding: 2rem;
			grid-template-areas: 'content formula' 'bullets formula'
		}

		.vip-rakeback-content {
				justify-content: center;
				padding-right: 2rem
		}

		:global(.vip-rakeback-title) {
				font-size: 38px !important
		}

		:global(.vip-rakeback-formula-card) {
				align-self: flex-end
		}
	}
</style>
